export const grid = {
  columns: 24,
  gutter: 20,
  margin: 0,
  maxWidth: {
    xs: "100%",
    sm: "100%",
    md: "100%",
    lg: "100%",
    xl: "1440px",
  },
};
